import { render, staticRenderFns } from "./Agree.vue?vue&type=template&id=6960a4c5&scoped=true"
import script from "./Agree.vue?vue&type=script&lang=js"
export * from "./Agree.vue?vue&type=script&lang=js"
import style0 from "./Agree.vue?vue&type=style&index=0&id=6960a4c5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6960a4c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6960a4c5')) {
      api.createRecord('6960a4c5', component.options)
    } else {
      api.reload('6960a4c5', component.options)
    }
    module.hot.accept("./Agree.vue?vue&type=template&id=6960a4c5&scoped=true", function () {
      api.rerender('6960a4c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/loginModal/Agree.vue"
export default component.exports